/**
 * True when the run will be sent with polycount_mode "unlimited": the toggle is on, the
 * active generation schema declares polycount_mode, and smart low poly (which always
 * uses a polygon target) is off. The flag can outlive a switch to an engine without the
 * toggle, so the schema check keeps it from disabling that engine's controls.
 * @param {Object} state - The 3D Studio store state
 * @returns {boolean}
 */
export const selectIsUnlimitedPolycount = state => Boolean(
  state.modelSettings.isUnlimitedPolycount
    && !state.modelSettings.isSmartLowPoly
    && state.schema.generationModelSchema?.input_schema?.properties?.polycount_mode,
)
